import {
  ExecutiveSummariesRoute,
  ExecutiveSummariesPathName,
} from '@/modules/ta/executivesummaries/executivesummaries.constants';
import { ExecutiveSummaryRouteConfig } from '@/modules/ta/executivesummaries/ExecutiveSummaryRouteConfig';

export const router = ExecutiveSummaryRouteConfig.factory([
  {
    path: `/${ExecutiveSummariesRoute.EXECUTIVESUMMARIES}`,
    name: ExecutiveSummariesPathName.EXECUTIVESUMMARIES,
    component: () =>
      import(
        /* webpackChunkName: "executivesummaries-page" */ './pages/ExecutiveSummariesPage.vue'
      ),
  },
]);
